import Repository from '@/repositories/marketing'
const categoriesResource = '/categories'
export default {
  /**
   * @use Product Feed Drawer
   */
  fetchHierarchy (payload, config) {
    return Repository.post(`${categoriesResource}/get_all_categories.json`, payload, config)
  },
}
